import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import '@alien-worlds/react-components/dist/index.css'
import TestPage from './InventoryScreen';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route path="/">
          <TestPage />
        </Route>
        <Route path="/b">
          <TestPage />
        </Route>
        <Route path="/c">
          <TestPage />
        </Route>
        <Route path="/d">
          <TestPage />
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
